import {api,baseUrl} from '../config.jsx'
export const apiSelect= async (url,myApi=null)=>
    {
       myApi=myApi ? myApi : api
       if(url !== undefined )
       {
         let paras= {
              method: 'GET'
          }
          let data= await fetch('https://'+myApi+'.'+baseUrl+url, paras)
          data= await data.json()
          return data
       }
    } 

